/* eslint no-restricted-globals: [2, "find"] */
import noop from 'lodash/noop';
import status from './status.json';
import {track, trackEnvProps} from '~/misc/metrics';

const log = () => {
  const t = window.performance.timing;
  let localStorageLength;
  try {
    localStorageLength = JSON.stringify(window.localStorage).length;
  } catch (e) {/* empty */}

  track('init_stats', {
    url: window.location.pathname,
    version: status.version,
    tz: (new Date()).getTimezoneOffset() / -60,
    transfer: t.responseEnd - t.responseStart,
    domComplete: t.domComplete - t.domInteractive,
    fullLoad: t.loadEventEnd ? (t.loadEventEnd - t.domLoading) : null,
    width: window.screen.availWidth,
    innerWidth: window.innerWidth,
    touch: 'ontouchstart' in window,
    localStorage: localStorageLength,
    referrer: window.document.referrer,
  });
};

const checkForUpdates = (store) =>
  fetch('/status.json').then(r => r.json()).then(json => {
    const {meta: {version: current}} = store.getState();

    const server = json.version;
    if (current === server) {
      trackEnvProps({
        version_outdated: '',
      });
    } else {
      trackEnvProps({
        version_outdated: current,
      });
    }
  }).catch(noop);

export default (store) => {
  window.setInterval(checkForUpdates.bind(null, store), 5 * 60 * 1000);

  if (!window.performance || !window.performance.timing) {
    return null;
  }
  if (window.document.readyState === 'complete') {
    return window.setTimeout(log, 1);
  }
  return window.addEventListener('load', log);
};



// WEBPACK FOOTER //
// ./src/initialmetrics.js